import {
    IS_LOADING_NOTIFICATIONS_ADDRESSEE, NOTIFICATIONS_ADDRESSEE, VIEW_NOTIFICATION, DELETE_NOTIFICATION_ADDRESSEE, ADD_NOTIFICATIONS_ADDRESSEE,
    IS_LOADING_VIEW_NOTIFICATION, IS_LOADING_CONFIGURATION_NOTIFICATIONS, CONFIGURATION_NOTIFICATION, IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION, CHANGE_CONFIGURATION_NOTIFICATION
} from '../actions/types'

const initialState = {


    isLoadingNotificationsAddresse: true,
    isLoadingNotificationsViewAddresse: false,
    listNotificationsAddresse: {
        request: [],
        othersNotifications: [],
        paymentsNotifications: [],
        pqrsNotifications: []
    },
    notificationAddresseView: [],
    isLoadingConfigurationNotifications: false,
    configurationNotification: {},
    isLoadingChangeConfigurationNotification: false,
    changeConfigurationNotification: {}

}

export default function (state = initialState, action) {
    switch (action.type) {


        case IS_LOADING_NOTIFICATIONS_ADDRESSEE:
            return { ...state, isLoadingNotificationsAddresse: true }
        case NOTIFICATIONS_ADDRESSEE:
            //  var addNotification = state.listNotificationsAddresse
            //    addNotification.request=action.payload
            return { ...state, isLoadingNotificationsAddresse: false, listNotificationsAddresse: action.payload }
        case ADD_NOTIFICATIONS_ADDRESSEE:
            var addNotification = state.listNotificationsAddresse
            if (action.payload.whoIsNotified ==="NSA" || action.payload.whoIsNotified ==="NSSC")
                addNotification.request.unshift(action.payload)
            else if (action.payload.whoIsNotified ==="NMP")
                addNotification.paymentsNotifications.unshift(action.payload)
            else
                addNotification.othersNotifications.unshift(action.payload)

            return { ...state, isLoadingNotificationsAddresse: false, listNotificationsAddresse: addNotification }
        case IS_LOADING_VIEW_NOTIFICATION:
            return { ...state, isLoadingNotificationsViewAddresse: true }
        case VIEW_NOTIFICATION:
            let viewNotification = state.listNotificationsAddresse
            viewNotification.request= viewNotification.request.filter((data) => {
                return data._id != action.payload
            })
            viewNotification.othersNotifications = viewNotification.othersNotifications.filter((data) => {
               
                return data._id != action.payload
            })
            return { ...state, isLoadingNotificationsAddresse: false, listNotificationsAddresse: viewNotification }
        case "ACCEPT_FRIEND_REQUEST2":
            var deleteNotification = state.listNotificationsAddresse.filter(ln => ln._id !== action.payload)
            // deleteNotification.othersNotifications.splice(action.payload, 1)
            return { ...state, isLoadingNotificationsAddresse: false, listNotificationsAddresse: deleteNotification }
        case DELETE_NOTIFICATION_ADDRESSEE:
            var deleteNotification = {
                request: state.listNotificationsAddresse.request,
                othersNotifications: state.listNotificationsAddresse.othersNotifications.filter(notification => notification._id !== action.payload)
            }

            return { ...state, isLoadingNotificationsAddresse: false, listNotificationsAddresse: deleteNotification }
        case IS_LOADING_CONFIGURATION_NOTIFICATIONS:
            return { ...state, isLoadingConfigurationNotifications: true }
        case CONFIGURATION_NOTIFICATION:
            return { ...state, isLoadingConfigurationNotifications: false, configurationNotification: action.payload }
        case IS_LOADING_CHANGE_CONFIGURATION_NOTIFICATION:
            return { ...state, isLoadingChangeConfigurationNotification: true }
        case CHANGE_CONFIGURATION_NOTIFICATION:
            return { ...state, isLoadingChangeConfigurationNotification: false, changeConfigurationNotification: action.payload }

        default:
            return state

    }
}